<template>
  <div>
    <div class="d-flex justify-start">
      <b>Periode:</b>
      <div class="ml-2">{{ turnoverObj.start | dateFormat }}</div>
      <div class="ml-2">{{ turnoverObj.end | dateFormat }}</div>
    </div>
    <v-row>
      <v-col cols="6" sm="3">
        <b>Grunnlag omsetning:</b>
      </v-col>
      <v-col cols="6" sm="1" class="text-right">
        {{ turnoverObj.basicturnover | replaceDotWithComma }}
      </v-col>
      <v-col cols="6" sm="3">
        <b>MVA:</b>
      </v-col>
      <v-col cols="6" sm="1" class="text-right">
        {{ turnoverObj.totalvat | replaceDotWithComma }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" sm="3" class="pt-0">
        <b>Grunnlag omsetning uten mva:</b>
      </v-col>
      <v-col cols="6" sm="1" class="pt-0 text-right">
        {{ turnoverObj.basicturnoverwithoutvat | replaceDotWithComma }}
      </v-col>
      <v-col cols="6" sm="3" class="pt-0">
        <b>{{ $t('message.reports.totalCosts') }}:</b>
      </v-col>
      <v-col cols="6" sm="1" class="pt-0 text-right">
       {{ turnoverObj.totalcost | replaceDotWithComma }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" sm="3" class="pt-0">
        <b>Sum omsetning netto:</b>
      </v-col>
      <v-col cols="6" sm="1" class="pt-0 text-right">
        {{ turnoverObj.totalturnover | replaceDotWithComma }}
      </v-col>
      <v-col cols="6" sm="3" class="pt-0">
        <b>{{ $t('message.reports.averageDG') }}:</b>
      </v-col>
      <v-col cols="6" sm="1" class="pt-0 text-right">
       {{ turnoverObj.averagedg | replaceDotWithComma }}
      </v-col>
    </v-row>
    <v-simple-table dense class="bordered--table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" v-for="(head, index) in headers" :key="index">{{ head }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in turnoverObj.invoicerecords" :key="index">
            <td>{{ data.number }}</td>
            <td>{{ data.customername }}</td>
            <td>{{ data.customergroupname }}</td>
            <td>{{ data.industry }}</td>
            <td>{{ data.invoicedate | dateFormat }}</td>
            <td>{{ data.currency }}</td>
            <td class="text-right">{{ data.sumexvat | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.sumexvatnok | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.vat | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.total | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.invoicetype === 1 ? '-' : '' }}{{ data.rounddown | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.totalcostnok | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.totaldbnok | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.dg | replaceDotWithComma }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
export default {
  props: ['turnoverObj'],
  data () {
    return {
      headers: ['Nr.', 'Kunde', 'Kundegruppe', 'Bransjer', 'Fakturdato', 'Valuta', 'eks.mva', 'eks.mva NOK', 'mva', 'Totalt NOK', 'Avrund', 'Totalt kost NOK', 'DB (NOK)', 'DG']
    }
  }
}
</script>
